


























































































































































































































































import { Vue, Component, Prop, Emit, Watch} from 'vue-property-decorator'
import store from '@/store'
import headers from './headers'
import moment from 'moment'
import Dialog from '../Dialog.vue'
import config from '../../../public/config.json'
import { ITranscoHyperProxi } from '../../store/modules/transco-hyper-proxi/types'
import { exportTransco } from '../../api/transco-hyper-proxi'
import { downloadCsvFileTransco } from '../../helper/csv-utils'


@Component< TranscoProvidersDataTable > ({})
  export default class TranscoProvidersDataTable extends Vue {

  get isAuthor() {
    return this.$store.getters.user.role === 'AUT'
  }

  get isCreated() {
    return this.$store.getters['transcoHyperProxi/isCreated']
  }

  get isModified() {
    return this.$store.getters['transcoHyperProxi/isModified']
  }

  get isDeleted() {
    return this.$store.getters['transcoHyperProxi/isDeleted']
  }

  get IsDowloading() {
    return this.isDowloading
  }

  get isLoading() {
    return this.$store.getters['transcoHyperProxi/isLoading']
  }

  get providerSearch() {
    return this.$store.getters['transcoHyperProxi/providerSearch']
  }

  set providerSearch(value) {
    this.$store.dispatch('transcoHyperProxi/updateProviderSearch', value)
  }

  get formTitle()  {
    return !this.editMode ? 'Création d\'une transco' : 'Modifier la transco'
  }

  get buttonText() {
    return !this.editMode ? 'Créer' : 'Modifier'
  }

  get Nomenclatures() {
    return this.$store.getters['nomenclatures/allNomenclatures']
  }

  @Prop({default: () => []})
    private items: any

  @Prop({default: () => []})
    private sortBy: any

  @Prop({default: () => []})
    private sortDesc: any

  private headers: any
  private editedItem: any
  private defaultItem: any
  private itemsPerPage: number
  private editMode: boolean
  private nomenclatures: []
  private dialog: boolean
  private hierarchy: []
  private valid: boolean
  private validSearch: boolean
  private rules: {}
  private creationDateHTML: string
  private updateDateHTML: string
  private snackBar: boolean
  private alertMessage: string
  private color: string
  private deleteDialog: boolean
  private itemToBeDeleted: any
  private suppliers: any[]
  private supplyErrors: any[]
  private page: number
  private pageCount: number
  private isDowloading: boolean

  public constructor() {
    super()

    this.headers = []
    this.itemsPerPage = store.getters.parameters('itemsPerPage')
    this.dialog = false
    this.editMode = false
    this.editedItem = {}
    this.nomenclatures = []
    this.defaultItem = {}
    this.valid = true
    this.validSearch = false
    this.creationDateHTML = ''
    this.updateDateHTML = ''
    this.hierarchy = []
    this.snackBar = false
    this.alertMessage = ''
    this.color = '#4CAF50'
    this.suppliers = []
    this.supplyErrors = []
    this.page = 1
    this.pageCount = 0
    this.isDowloading = false


    const specialChars = (v: string) => /^[a-zA-Z0-9]*$/.test(v) || 'Caractères spéciaux interdits'
    const required = (v: string, errMessage: string) => !!v || errMessage

    this.rules = {
      tvaRules: [(v: string) => required(v, 'Le code TVA est requis.')],
      hyperRules:
      [
        (v: string) => required(v, 'Le code Hyper est requis.'),
        (v: string) => specialChars(v),
      ],
      superRules:
      [
        (v: string) => required(v, 'Le code Super est requis.'),
        (v: string) => specialChars(v),
      ],
      searchRules: [
        (v: string) => (v && v.trim().length >= 3) || '3 caractères minimum.',
        (v: string) => (v && v.trim().length <= 30) || '30 caractères maximum.',
      ],
    }
    this.deleteDialog = false
    this.itemToBeDeleted = null
  }

  public async getCsvFile() {
    this.isDowloading = true
    const data = await exportTransco()
    this.isDowloading = false
    downloadCsvFileTransco(data)
  }

  public async mounted() {
    this.headers = this.isAuthor ? headers : headers.slice(1)
    await this.$store.dispatch('nomenclatures/getNomenclatures')
    this.nomenclatures = this.$store.getters['nomenclatures/allNomenclatures']
  }

  @Watch('dialog')
    public dialogWatch(val: any, old: any, item: any) {

    if (!this.editedItem.creationDate) {
      this.editedItem.creationDate = new Date()
    }
    if (!this.editedItem.updateDate) {
      this.editedItem.updateDate = new Date()
    }

    this.updateDateHTML = this.momentDate(this.editedItem.updateDate)
    this.creationDateHTML = this.momentDate(this.editedItem.creationDate)

    if (!val) {
      this.close()
    }
  }

  @Watch('isCreated')
    public dialogIsCreated(isCreated: boolean) {
    if (isCreated) {
      this.showSnackBar(true, 'Transco ajoutée et en cours de traitement.')
    }
  }

  @Watch('isModified')
    public dialogIsModified(isModified: boolean) {
    if (isModified) {
      this.showSnackBar(true, 'Transco modifiée et en cours de traitement.')
    }
  }

  @Watch('isDeleted')
    public dialogIsDeleted(isDeleted: boolean) {
    if (isDeleted) {
      this.showSnackBar(true, 'Transco supprimée et en cours de traitement.')
    }
  }


  public async editItem(item: any) {
    this.suppliers = []
    await this.getSuppliers(item.hyperCode)
    this.editedItem.updateDate = new Date()
    this.updateDateHTML = this.momentDate(this.editedItem.updateDate)
    this.editMode = true
    this.editedItem = {...item}
    if (this.editedItem.proxiHierarchyList) {
      this.editedItem.proxiHierarchyList = this.editedItem.proxiHierarchyList.map((i: any) => i.hierarchyElementCode)
    }
    this.dialog = true
  }

  public close() {
    this.dialog = false
    this.editMode = false
    this.editedItem = {}
    this.suppliers = []
    this.resetForm()
  }

  public remove(item: any) {
    this.editedItem.proxiHierarchyList = this.editedItem.proxiHierarchyList.filter((id: string) => id !== item.id)
  }

  public save() {
    if (this.editedItem.proxiHierarchyList) {
      this.editedItem.proxiHierarchyList = this.editedItem.proxiHierarchyList.map((id: any) => {
        return {hierarchyElementCode: id}
      })
    }
    this.setSupplyLabel(this.editedItem.hyperCode)
    if (this.editMode) {
      // Update
      try {
        // call dispatch modif
        this.$store.dispatch('transcoHyperProxi/patchTransco', this.editedItem)
        if (this.editedItem.proxiHierarchyList) {
          this.editedItem.proxiHierarchyList = this.editedItem.proxiHierarchyList.map((id: any) => {
            return {hierarchyElementCode: id}
          })
        }
        this.showSnackBar(true, 'Transco modifiée et en cours de traitement.')
      } catch (error) {
        this.alertMessage = error.message
      }
    } else {
      try {
        this.$store.dispatch('transcoHyperProxi/putTransco', this.editedItem)
      } catch (error) {
        this.alertMessage = error.message
      }
    }
    this.close()
  }

  public resetForm() {
    (this.$refs.form as HTMLFormElement).reset()
  }

  public deleteItemPopin(item: any) {
    this.deleteDialog = true
    this.itemToBeDeleted = item
  }

  public validateDeletion() {
    this.deleteDialog = false
    this.$store.dispatch('transcoHyperProxi/deleteTransco', this.itemToBeDeleted)
  }

  public validate() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.valid = false
      this.save()
    } else {
      this.resetForm()
      this.valid = true
    }
  }

  public momentDate(date: Date) {
    return date ? moment(date).format('DD/MM/YYYY') : ''
  }

  public showSnackBar(success: boolean, message: string) {
    this.color = success ? '#4CAF50' : '#F44336'
    this.alertMessage = message
    this.snackBar = true
  }

  public validateSearch() {
    this.validSearch = (this.$refs.searchForm as Vue & { validate: () => boolean }).validate()
  }

  public async searchProviders() {
    this.validateSearch()
    if (!this.$store.getters['transcoHyperProxi/isLoading'] && this.validSearch) {
      await this.$store.dispatch('transcoHyperProxi/searchProviders',
        this.$store.getters['transcoHyperProxi/providerSearch'])
    }
  }

  private async getSuppliers(supplyCode: string) {
    await this.$store.dispatch('suppliers/searchSupply', supplyCode)
    this.suppliers = this.$store.getters['suppliers/searchSupply']
      .map((s: any) => {
        return {
          ...s,
          text: s.id + ' - ' + s.label,
        }
      })
  }

  private setSupplyLabel(supplyCode: string) {
    if (this.suppliers.length > 0) {
      this.editedItem.supplierLabel = this.suppliers.find((s: any) => s.id === supplyCode).label
    }
  }

  private async loadSuppliers(event: any) {
    if (event.target.value.length > 2) {
      await this.getSuppliers(event.target.value)
    } else {
      this.suppliers = []
    }
  }

  private proxiHierarchyListFilter(item: any, queryText: string, itemText: string) {
    return (
      item.id.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
      item.label.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
    )
  }

}
